import styled from 'styled-components'

const AppBar = styled.header`
  padding: 0 1rem;
  background-color: var(--light);
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  align-items: center;
  height: var(--header-menu-height);
  z-index: 2;
  position: relative;

  &.sticky {
    position: sticky;
    left: 0;
    right: 0;
    top: 0;
    margin: auto;
    width: 100%;
  }

  @media screen and (min-width: 48rem) {
    padding: 0 2.25rem;
  }
`

export default AppBar
